import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle2, Clock, Hourglass, XCircle } from "lucide-react";
import { publicError } from "@/lib/publicErrors";

const ICONS = {
  expired: { Icon: Clock, cls: "text-warn" },
  done: { Icon: CheckCircle2, cls: "text-ok" },
  blocked: { Icon: Hourglass, cls: "text-warn" },
  invalid: { Icon: XCircle, cls: "text-destructive" },
  generic: { Icon: XCircle, cls: "text-destructive" },
} as const;

/**
 * Full-page state for the token-gated pages (/sign/*, /pay, /feedback) when
 * the Edge Function refuses the token. Translates the raw error code into
 * pt-BR copy and tells the client what to do next.
 */
export function PublicErrorCard({ code }: { code: string | null | undefined }) {
  const e = publicError(code);
  const { Icon, cls } = ICONS[e.kind];
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <Card className="w-full max-w-md rounded-2xl border-border shadow-card">
        <CardContent className="p-8 text-center">
          <Icon className={`mx-auto mb-3 h-12 w-12 ${cls}`} />
          <h2 className="font-semibold text-foreground">{e.title}</h2>
          <p className="mt-1 text-sm text-muted-foreground">{e.message}</p>
          {e.kind !== "done" && (
            <p className="mt-4 text-xs text-muted-foreground">
              Precisa de ajuda?{" "}
              <a href="https://eliveutonsouza.com/contato" className="underline">
                Fale com Eliveuton
              </a>
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
